import roles from "@/roles";
export default [
  {
    icon: "attach_money",
    title: "Billing",
    roles: [roles.ADMIN, roles.BILLING_ADMIN],
    children: [
      {
        router: true,
        title: "Preliminary Billing",
        to: "PreliminaryBilling",
        roles: [roles.ADMIN, roles.BILLING_ADMIN]
      },
      {
        router: true,
        title: "Weekly P&L Input",
        to: "FixedCost",
        roles: [roles.ADMIN, roles.BILLING_ADMIN]
      }
    ]
  }
];
